import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {useTranslation} from "react-i18next";

import NavBar from "../Navbar/Navbar.js";
import Header from "../Header/Header.js";
import axiosInstance from "../axiosConfig.js";
import {useUser} from "../UserContext";

import { hideLoading, showLoading } from "../store/loadingSlice.js";

import "./WebCRM.css";

const WebCRM = () => {
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();
    const [isNavOpen, setIsNavOpen] = useState(true);
    const [events, setEvents] = useState([]);
    const [error, setError] = useState("");
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [editedSxolia, setEditedSxolia] = useState("");
    const [originalSxolia, setOriginalSxolia] = useState("");
    const [isSavingEvent, setIsSavingEvent] = useState(false);
    const [isCompletingEvent, setIsCompletingEvent] = useState(false);
    const [isCancelingEvent, setIsCancelingEvent] = useState(false);
    const [isReadingEvent, setIsReadingEvent] = useState(false);
    const [saveEventError, setSaveEventError] = useState("");

    const { username, companyName } = useUser();

    const licenseData = useSelector((state) => state.liscence.modules);

    const staticData = useSelector(state => state.static.static);

    const actor = staticData.actor;

    const company = licenseData?.company_id;

    const getLocalDateString = (date = new Date()) => {
        const year = date.getFullYear();

        const month = String(date.getMonth() + 1).padStart(2, "0");

        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };
    const [selectedDate, setSelectedDate] = useState(getLocalDateString());

    const toggleNav = () => {
        setIsNavOpen((prev) => !prev);
    };

    const formatDateForSoftOne = (date) => date.replaceAll("-", "");

    const parseSoftOneDate = (value) => {
        if (!value) {
            return null;
        }

        if (
            value instanceof Date
        ) {
            return Number.isNaN(
                value.getTime()
            )
                ? null
                : value;
        }

        const stringValue = String(value).trim();

        const dateMatch = stringValue.match(/^(\d{4})-(\d{2})-(\d{2})/);

        if (dateMatch) {
            const [, year, month, day] = dateMatch;

            const parsed = new Date(Number(year), Number(month) - 1, Number(day));

            return Number.isNaN(
                parsed.getTime()
            )
                ? null
                : parsed;
        }

        const parsed = new Date(stringValue.replace(" ", "T"));

        return Number.isNaN(
            parsed.getTime()
        )
            ? null
            : parsed;
    };

    const formatShortDate = (value) => {
        const date = parseSoftOneDate(value);

        if (!date) {
            return "--/--/----";
        }

        const day = String(date.getDate()).padStart(2, "0");

        const month = String(date.getMonth() + 1).padStart(2, "0");

        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const formatFullDate = (dateString) => {
        if (!dateString) {
            return "";
        }
        const [year, month, day] = dateString.split("-");

        const date = new Date(Number(year), Number(month) - 1, Number(day));

        const locale =
            i18n.language === "gr"
                ? "el-GR"
                : i18n.language ===
                  "ro"
                ? "ro-RO"
                : "en-GB";

        return date.toLocaleDateString(
            locale,
            {
                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric",
            }
        );
    };

    const getEventKey = (event) => event?.CCCXITTENTOLES ?? event?.cccxittentoles ?? null;

    const getStatusType = (event) => {
        const statusId = Number(event?.statusid);

        if (statusId === 2) {
            return "done";
        }

        if (statusId === 3) {
            return "canceled";
        }

        if (statusId === 4) {
            return "read";
        }

        return "pending";
    };

    const isEventDone = (event) => getStatusType(event) === "done";

    const isEventCanceled = (event) => getStatusType(event) === "canceled";

    const isEventRead = (event) => getStatusType(event) === "read";

    const getStatusText = (event) => {
        const type = getStatusType(event);

        if (type === "done") {
            return t("Done");
        }

        if (
            type === "canceled"
        ) {
            return t("Canceled");
        }

        if (type === "read") {
            return t("Read");
        }

        return t("Pending");
    };

    const fetchEvents =
        useCallback(
            async (
                showMainLoader = true
            ) => {
                if (
                    !licenseData?.company_url
                ) {
                    console.error("[WebCRM] Missing company_url", { licenseData, });

                    return;
                }

                if (
                    !licenseData?.appid
                ) {
                    console.error("[WebCRM] Missing appId", { licenseData, });

                    setError(
                        t(
                            "SoftOneAppIdMissing"
                        )
                    );

                    return;
                }

                if (
                    showMainLoader
                ) {
                    dispatch(
                        showLoading()
                    );
                } else {
                    setIsRefreshing(true);
                }

                setError("");

                const parameters = {
                    url: `https://${licenseData.company_url}/s1services`,

                    service:
                        "SqlData",

                    clientID:
                        localStorage.getItem("token"),

                    appId:
                        licenseData.appid,

                    SqlName:
                        "10030",

                    company,

                    actor,

                    trndate:
                        formatDateForSoftOne(selectedDate),
                };

                console.group("🔵 [WebCRM] SoftOne Orders Request");

                console.log("Request time:", new Date().toLocaleString());

                console.log("Selected date:", selectedDate);

                console.log("SoftOne formatted date:", formatDateForSoftOne(selectedDate));

                console.log("Company:", company);

                console.log("Actor:", actor);

                console.log("Company URL:", licenseData.company_url);

                console.log("App ID:", licenseData.appid);

                console.log("API endpoint:", "/api");

                console.log("Client ID exists:", !!localStorage.getItem("token"));

                console.log("Request parameters:", { ...parameters, clientID: parameters.clientID ? `${parameters.clientID.substring( 0, 5 )}...` : null, });

                console.groupEnd();

                try {
                    const requestStart = performance.now();

                    const response = await axiosInstance.post("/api", parameters);

                    const requestEnd = performance.now();

                    console.group("🟢 [WebCRM] SoftOne Orders Response");

                    console.log("Response time:", `${Math.round(requestEnd - requestStart)} ms`);

                    console.log("HTTP status:", response.status);

                    console.log("HTTP status text:", response.statusText);

                    console.log("Response headers:", response.headers);

                    console.log("Full SoftOne response:", response.data);

                    console.log("SoftOne success:", response?.data?.success);

                    console.log("Total count:", response?.data?.totalcount);

                    console.log("Rows:", response?.data?.rows);

                    console.groupEnd();

                    if (
                        response?.data
                           ?.success
                    ) {
                        const rows =
                            Array.isArray(
                                response
                                   ?.data
                                   ?.rows
                            )
                                ? response
                                      .data
                                      .rows
                                : [];

                        const sortedEvents =
                            [...rows].sort(
                                (
                                    a,
                                    b
                                ) => {
                                    const dateA =
                                        parseSoftOneDate(a?.imerominia);

                                    const dateB =
                                        parseSoftOneDate(b?.imerominia);

                                    if (
                                        dateA &&
                                        dateB &&
                                        dateA.getTime() !==
                                            dateB.getTime()
                                    ) {
                                        return (
                                            dateA -
                                            dateB
                                        );
                                    }

                                    return String(
                                        a?.pelatis ||
                                            ""
                                    ).localeCompare(
                                        String(
                                            b?.pelatis ||
                                                ""
                                        )
                                    );
                                }
                            );

                        console.log("📋 [WebCRM] Orders loaded:", sortedEvents.length);

                        console.table(sortedEvents.map( ( event ) => ({ id: getEventKey(event), imerominia: event?.imerominia, pelatis: event?.pelatis, eteria: event?.eteria, statusid: event?.statusid, katastasi: event?.katastasi, oxima: event?.oxima, odigos: event?.odigos, sxolia: event?.sxolia, }) ));

                        setEvents(sortedEvents);
                    } else {
                        console.error("🔴 [WebCRM] SoftOne returned success=false", response?.data);

                        setEvents([]);

                        setError(
                            response?.data
                               ?.message ||
                                t(
                                    "SoftOneOrdersError"
                                )
                        );
                    }
                } catch (err) {
                    console.group("🔴 [WebCRM] SoftOne API ERROR");

                    console.error("Full error:", err);

                    console.error("Error message:", err?.message);

                    console.error("Axios error code:", err?.code);

                    console.error("HTTP status:", err?.response?.status);

                    console.error("HTTP status text:", err?.response?.statusText);

                    console.error("Server response:", err?.response?.data);

                    console.error("Response headers:", err?.response?.headers);

                    console.error("Request config:", err?.config);

                    console.error("Request URL:", err?.config?.url);

                    console.error("Request method:", err?.config?.method);

                    console.error("Request body:", err?.config?.data);

                    console.error("Original WebCRM parameters:", { ...parameters, clientID: parameters.clientID ? `${parameters.clientID.substring( 0, 5 )}...` : null, });

                    console.groupEnd();

                    setEvents([]);

                    setError(
                        err?.response
                           ?.data
                           ?.message ||
                            err?.message ||
                            t(
                                "UnableToLoadOrders"
                            )
                    );
                } finally {
                    console.log("⚪ [WebCRM] API request finished");

                    if (
                        showMainLoader
                    ) {
                        dispatch(
                            hideLoading()
                        );
                    }

                    setIsRefreshing(false);
                }
            },
            [
                actor,
                company,
                dispatch,
                licenseData?.appid,
                licenseData?.company_url,
                selectedDate,
                t,
            ]
        );

    useEffect(() => { fetchEvents(); }, [fetchEvents]);
    const completedCount = useMemo(() => events.filter((event) => isEventDone(event)).length, [events]);
    const canceledCount = useMemo(() => events.filter((event) => isEventCanceled(event)).length, [events]);
    const readCount = useMemo(() => events.filter((event) => isEventRead(event)).length, [events]);
    const pendingCount = useMemo(() => events.filter((event) => getStatusType(event) === "pending").length, [events]);

    const moveDate = (amount) => {
        const [
            year,
            month,
            day,
        ] = selectedDate
            .split("-")
            .map(Number);

        const currentDate = new Date(year, month - 1, day);

        currentDate.setDate(
            currentDate.getDate() +
                amount
        );

        setSelectedDate(getLocalDateString(currentDate));
    };

    const goToToday = () => {
        setSelectedDate(getLocalDateString());
    };

    const resetEventModal =
        () => {
            setSelectedEvent(null);

            setEditedSxolia("");

            setOriginalSxolia("");

            setSaveEventError("");
        };

    const openEventModal = (event) => {
        const sxolia = event?.sxolia || "";

        setSelectedEvent(event);

        setEditedSxolia(sxolia);

        setOriginalSxolia(sxolia);

        setSaveEventError("");
    };

    const modalBusy = isSavingEvent || isCompletingEvent || isCancelingEvent || isReadingEvent;

    const closeEventModal =
        () => {
            if (modalBusy) {
                return;
            }

            resetEventModal();
        };

    const hasSxoliaChanged = editedSxolia !== originalSxolia;

    const saveEventSxolia =
        async () => {
            const eventKey = getEventKey(selectedEvent);

            if (!eventKey) {
                console.error("[WebCRM] Cannot save order. Missing CCCXITTENTOLES:", selectedEvent);

                setSaveEventError(t( "WebCRMMissingOrderId" ));

                return;
            }

            if (
                !hasSxoliaChanged
            ) {
                console.log("[WebCRM] Sxolia unchanged. SetData request skipped.");

                return;
            }

            setIsSavingEvent(true);

            setSaveEventError("");

            const parameters = {
                url: `https://${licenseData.company_url}/s1services`,
                service:"setData",
                clientID: localStorage.getItem("token"),
                appId:licenseData.appid,
                OBJECT:"CCCXITOENTOLES",
                KEY:String(eventKey),
                data: {
                    CCCXITTENTOLES:
                        [
                            {
                                CCCXITSXOLIA:editedSxolia,
                            },
                        ],
                },
            };

            console.group("🔵 [WebCRM] Save Sxolia");

            console.log("CCCXITTENTOLES:", eventKey);

            console.log("Original sxolia:", originalSxolia);

            console.log("New sxolia:", editedSxolia);

            console.log("Request:", { ...parameters, clientID: parameters.clientID ? `${parameters.clientID.substring( 0, 5 )}...` : null, });

            console.groupEnd();

            try {
                const response =
                    await axiosInstance.post(
                        "/api",
                        parameters
                    );

                console.log("🟢 [WebCRM] Save sxolia response:", response?.data);

                if (
                    response?.data
                       ?.success
                ) {
                    setEvents(
                        (
                            currentEvents
                        ) =>
                            currentEvents.map(
                                (
                                    event
                                ) =>
                                    String(
                                        getEventKey(event)
                                    ) ===
                                    String(eventKey)
                                        ? {
                                              ...event,

                                              sxolia:
                                                  editedSxolia,
                                          }
                                        : event
                            )
                    );

                    resetEventModal();
                } else {
                    console.error("🔴 [WebCRM] Save returned success=false:", response?.data);

                    setSaveEventError(response?.data?.error || response?.data?.message || t( "WebCRMUnableToSave" ));
                }
            } catch (err) {
                console.error("🔴 [WebCRM] Error saving sxolia:", err);

                console.error("Server response:", err?.response?.data);

                setSaveEventError(err?.response?.data?.message || err?.message || t( "WebCRMUnableToSave" ));
            } finally {
                setIsSavingEvent(false);
            }
        };

    const completeEvent =
        async () => {
            const eventKey = getEventKey(selectedEvent);

            if (!eventKey) {
                console.error("[WebCRM] Cannot complete order. Missing CCCXITTENTOLES:", selectedEvent);

                setSaveEventError(t( "WebCRMMissingOrderId" ));

                return;
            }

            if (
                isEventDone(selectedEvent)
            ) {
                return;
            }

            setIsCompletingEvent(true);

            setSaveEventError("");

            const parameters = {
                url: `https://${licenseData.company_url}/s1services`,

                service:
                    "setData",

                clientID:
                    localStorage.getItem("token"),

                appId:
                    licenseData.appid,

                OBJECT:
                    "CCCXITOENTOLES",

                KEY:
                    String(eventKey),

                data: {
                    CCCXITTENTOLES:
                        [
                            {
                                CCCXITSXOLIA: editedSxolia,
                                CCCXITKATASTASI: 2,
                            },
                        ],
                },
            };

            console.group("🟢 [WebCRM] Complete Order");

            console.log("CCCXITTENTOLES:", eventKey);

            console.log("Sxolia:", editedSxolia);

            console.log("New status:", 2);

            console.log("Request:", { ...parameters, clientID: parameters.clientID ? `${parameters.clientID.substring( 0, 5 )}...` : null, });

            console.groupEnd();

            try {
                const response =
                    await axiosInstance.post(
                        "/api",
                        parameters
                    );

                console.log("🟢 [WebCRM] Complete order response:", response?.data);

                if (
                    response?.data
                       ?.success
                ) {
                    setEvents(
                        (
                            currentEvents
                        ) =>
                            currentEvents.map(
                                (
                                    event
                                ) =>
                                    String(
                                        getEventKey(event)
                                    ) ===
                                    String(eventKey)
                                        ? {
                                              ...event,

                                              sxolia:
                                                  editedSxolia,

                                              statusid:
                                                  2,

                                              katastasi:
                                                  t(
                                                      "Done"
                                                  ),
                                          }
                                        : event
                            )
                    );

                    resetEventModal();
                } else {
                    console.error("🔴 [WebCRM] Complete returned success=false:", response?.data);

                    setSaveEventError(response?.data?.error || response?.data?.message || t( "WebCRMUnableToComplete" ));
                }
            } catch (err) {
                console.error("🔴 [WebCRM] Error completing order:", err);

                console.error("Server response:", err?.response?.data);

                setSaveEventError(err?.response?.data?.message || err?.message || t( "WebCRMUnableToComplete" ));
            } finally {
                setIsCompletingEvent(false);
            }
        };

    const cancelEvent =
        async () => {
            const eventKey = getEventKey(selectedEvent);

            if (!eventKey) {
                console.error("[WebCRM] Cannot cancel order. Missing CCCXITTENTOLES:", selectedEvent);

                setSaveEventError(t( "WebCRMMissingOrderId" ));

                return;
            }

            if (
                isEventCanceled(selectedEvent)
            ) {
                return;
            }

            setIsCancelingEvent(true);

            setSaveEventError("");

            const parameters = {
                url: `https://${licenseData.company_url}/s1services`,

                service:
                    "setData",

                clientID:
                    localStorage.getItem("token"),

                appId:
                    licenseData.appid,

                OBJECT:
                    "CCCXITOENTOLES",

                KEY:
                    String(eventKey),

                data: {
                    CCCXITTENTOLES:
                        [
                            {
                                CCCXITSXOLIA:editedSxolia,
                                CCCXITKATASTASI: 3,
                            },
                        ],
                },
            };

            console.group("🔴 [WebCRM] Cancel Order");

            console.log("CCCXITTENTOLES:", eventKey);

            console.log("Sxolia:", editedSxolia);

            console.log("New status:", 3);

            console.log("Request:", { ...parameters, clientID: parameters.clientID ? `${parameters.clientID.substring( 0, 5 )}...` : null, });

            console.groupEnd();

            try {
                const response =
                    await axiosInstance.post(
                        "/api",
                        parameters
                    );

                console.log("🟢 [WebCRM] Cancel order response:", response?.data);

                if (
                    response?.data
                       ?.success
                ) {
                    setEvents(
                        (
                            currentEvents
                        ) =>
                            currentEvents.map(
                                (
                                    event
                                ) =>
                                    String(
                                        getEventKey(event)
                                    ) ===
                                    String(eventKey)
                                        ? {
                                              ...event,

                                              sxolia:
                                                  editedSxolia,

                                              statusid:
                                                  3,

                                              katastasi:
                                                  t(
                                                      "Canceled"
                                                  ),
                                          }
                                        : event
                            )
                    );

                    resetEventModal();
                } else {
                    console.error("🔴 [WebCRM] Cancel returned success=false:", response?.data);

                    setSaveEventError(response?.data?.error || response?.data?.message || t( "WebCRMUnableToCancel" ));
                }
            } catch (err) {
                console.error("🔴 [WebCRM] Error canceling order:", err);

                console.error("Server response:", err?.response?.data);

                setSaveEventError(err?.response?.data?.message || err?.message || t( "WebCRMUnableToCancel" ));
            } finally {
                setIsCancelingEvent(false);
            }
        };

    const readEvent =
        async () => {
            const eventKey = getEventKey(selectedEvent);

            if (!eventKey) {
                console.error("[WebCRM] Cannot mark order as read. Missing CCCXITTENTOLES:", selectedEvent);

                setSaveEventError(t( "WebCRMMissingOrderId" ));

                return;
            }

            if (
                isEventRead(selectedEvent)
            ) {
                return;
            }

            setIsReadingEvent(true);

            setSaveEventError("");

            const parameters = {
                url: `https://${licenseData.company_url}/s1services`,

                service:
                    "setData",

                clientID:
                    localStorage.getItem("token"),

                appId:
                    licenseData.appid,

                OBJECT:
                    "CCCXITOENTOLES",

                KEY:
                    String(eventKey),

                data: {
                    CCCXITTENTOLES:
                        [
                            {
                                CCCXITSXOLIA: editedSxolia,
                                CCCXITKATASTASI: 4,
                            },
                        ],
                },
            };

            console.group("🔵 [WebCRM] Mark Order Read");

            console.log("CCCXITTENTOLES:", eventKey);

            console.log("Sxolia:", editedSxolia);

            console.log("New status:", 4);

            console.log("Request:", { ...parameters, clientID: parameters.clientID ? `${parameters.clientID.substring( 0, 5 )}...` : null, });

            console.groupEnd();

            try {
                const response =
                    await axiosInstance.post(
                        "/api",
                        parameters
                    );

                console.log("🟢 [WebCRM] Read order response:", response?.data);

                if (
                    response?.data
                       ?.success
                ) {
                    setEvents(
                        (
                            currentEvents
                        ) =>
                            currentEvents.map(
                                (
                                    event
                                ) =>
                                    String(
                                        getEventKey(event)
                                    ) ===
                                    String(eventKey)
                                        ? {
                                              ...event,

                                              sxolia:
                                                  editedSxolia,

                                              statusid:
                                                  4,

                                              katastasi:
                                                  t(
                                                      "Read"
                                                  ),
                                          }
                                        : event
                            )
                    );

                    resetEventModal();
                } else {
                    console.error("🔴 [WebCRM] Read returned success=false:", response?.data);

                    setSaveEventError(response?.data?.error || response?.data?.message || t( "WebCRMUnableToSave" ));
                }
            } catch (err) {
                console.error("🔴 [WebCRM] Error marking order as read:", err);

                console.error("Server response:", err?.response?.data);

                setSaveEventError(err?.response?.data?.message || err?.message || t( "WebCRMUnableToSave" ));
            } finally {
                setIsReadingEvent(false);
            }
        };

    return (
        <div id="webcrm">
            <div
                className={`container-card ${
                    isNavOpen
                        ? "nav-open"
                        : "nav-closed"
                }`}
            >
                <NavBar
                    toggleNav={toggleNav}
                />

                <div className="dashboard-content">
                    <Header
                        username={username}
                        companyName={companyName}
                    />

                    <main className="webcrm-main">
                        <section className="webcrm-heading">
                            <div className="webcrm-heading-center">
                                <div className="webcrm-softone-title">
                                    <img
                                        src="/entersoftone-logo.png"
                                        alt="SoftOne"
                                        className="webcrm-softone-logo"
                                    />
                                </div>

                                <div className="webcrm-heading-copy">
                                    <span className="webcrm-eyebrow">
                                        {t("WebCRM")}
                                    </span>

                                    <p>
                                        {t("WebCRMDescription")}
                                    </p>
                                </div>
                            </div>

                            <button
                                className={`webcrm-refresh-btn ${
                                    isRefreshing
                                        ? "refreshing"
                                        : ""
                                }`}
                                type="button"
                                onClick={() =>
                                    fetchEvents(false)
                                }
                                disabled={isRefreshing}
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    width="18"
                                    height="18"
                                    fill="none"
                                >
                                    <path
                                        d="M20 6V10H16"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />

                                    <path
                                        d="M4 18V14H8"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />

                                    <path
                                        d="M6.1 9A7 7 0 0118.4 6.6L20 10"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />

                                    <path
                                        d="M17.9 15A7 7 0 015.6 17.4L4 14"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                                {isRefreshing
                                    ? t(
                                          "Refreshing"
                                      )
                                    : t(
                                          "Refresh"
                                      )}
                            </button>
                        </section>

                        <section className="webcrm-calendar-panel">
                            <div className="webcrm-calendar-left">
                                <div className="calendar-icon-box">
                                    <svg
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        fill="none"
                                    >
                                        <rect
                                            x="3"
                                            y="5"
                                            width="18"
                                            height="16"
                                            rx="3"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        />

                                        <path
                                            d="M7 3V7M17 3V7M3 10H21"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </div>

                                <div>
                                    <span className="calendar-label">
                                        {t("SelectedDate")}
                                    </span>

                                    <strong>
                                        {formatFullDate(selectedDate)}
                                    </strong>
                                </div>
                            </div>

                            <div className="webcrm-date-controls">
                                <button
                                    type="button"
                                    className="date-arrow-btn"
                                    onClick={() =>
                                        moveDate(
                                            -1
                                        )
                                    }
                                    title={t("PreviousDay")}
                                >
                                    ‹
                                </button>

                                <input
                                    type="date"
                                    value={selectedDate}
                                    onChange={(
                                        e
                                    ) =>
                                        setSelectedDate(
                                            e
                                                .target
                                                .value
                                        )
                                    }
                                    className="webcrm-date-input"
                                />

                                <button
                                    type="button"
                                    className="date-arrow-btn"
                                    onClick={() =>
                                        moveDate(
                                            1
                                        )
                                    }
                                    title={t("NextDay")}
                                >
                                    ›
                                </button>

                                <button
                                    className="today-btn"
                                    type="button"
                                    onClick={goToToday}
                                >
                                    {t("Today")}
                                </button>
                            </div>
                        </section>

                        <section className="webcrm-summary">
                            <div className="summary-item">
                                <div className="summary-icon summary-icon-blue">
                                    <svg
                                        viewBox="0 0 24 24"
                                        width="20"
                                        height="20"
                                        fill="none"
                                    >
                                        <path
                                            d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </div>

                                <div>
                                    <span>
                                        {t("Orders")}
                                    </span>

                                    <strong>
                                        {events.length}
                                    </strong>
                                </div>
                            </div>

                            <div className="summary-divider" />

                            <div className="summary-item">
                                <div className="summary-icon summary-icon-orange">
                                    <span className="summary-status-dot pending" />
                                </div>

                                <div>
                                    <span>
                                        {t("Pending")}
                                    </span>

                                    <strong>
                                        {pendingCount}
                                    </strong>
                                </div>
                            </div>

                            <div className="summary-divider" />

                            <div className="summary-item">
                                <div className="summary-icon summary-icon-green">
                                    <span className="summary-status-dot done" />
                                </div>

                                <div>
                                    <span>
                                        {t("Completed")}
                                    </span>

                                    <strong>
                                        {completedCount}
                                    </strong>
                                </div>
                            </div>

                            <div className="summary-divider" />

                            <div className="summary-item">
                                <div className="summary-icon summary-icon-red">
                                    <span className="summary-status-dot canceled" />
                                </div>

                                <div>
                                    <span>
                                        {t("Canceled")}
                                    </span>

                                    <strong>
                                        {canceledCount}
                                    </strong>
                                </div>
                            </div>

                            <div className="summary-divider" />

                            <div className="summary-item">
                                <div className="summary-icon summary-icon-read">
                                    <span className="summary-status-dot read" />
                                </div>

                                <div>
                                    <span>{t("Read")}</span>
                                    <strong>{readCount}</strong>
                                </div>
                            </div>

                            <div className="summary-divider" />

                            <div className="summary-item">
                                <div className="summary-icon summary-icon-softone">
                                    <span className="status-dot" />
                                </div>

                                <div>
                                    <span>
                                        {t("SoftOne")}
                                    </span>

                                    <strong className="connected-text">
                                        {t("Connected")}
                                    </strong>
                                </div>
                            </div>
                        </section>

                        {error && (
                            <div className="webcrm-error">
                                <div className="error-icon">
                                    !
                                </div>

                                <div>
                                    <strong>
                                        {t("CouldNotLoadOrders")}
                                    </strong>

                                    <span>
                                        {error}
                                    </span>
                                </div>

                                <button
                                    type="button"
                                    onClick={() =>
                                        fetchEvents(false)
                                    }
                                >
                                    {t("TryAgain")}
                                </button>
                            </div>
                        )}

                        <section className="agenda-section">
                            <div className="agenda-header">
                                <div>
                                    <span className="agenda-caption">
                                        {t("Schedule")}
                                    </span>

                                    <h2>
                                        {t("TodaysOrders")}
                                    </h2>
                                </div>

                                <div className="agenda-count">
                                    {events.length}

                                    <span>
                                        {events.length ===
                                        1
                                            ? ` ${t("Order")}`
                                            : ` ${t("Orders")}`}
                                    </span>
                                </div>
                            </div>

                            {events.length ===
                                0 &&
                            !error ? (
                                <div className="webcrm-empty-state">
                                    <div className="empty-state-icon">
                                        <svg
                                            viewBox="0 0 24 24"
                                            width="34"
                                            height="34"
                                            fill="none"
                                        >
                                            <rect
                                                x="3"
                                                y="5"
                                                width="18"
                                                height="16"
                                                rx="3"
                                                stroke="currentColor"
                                                strokeWidth="1.7"
                                            />

                                            <path
                                                d="M7 3V7M17 3V7M3 10H21"
                                                stroke="currentColor"
                                                strokeWidth="1.7"
                                                strokeLinecap="round"
                                            />

                                            <path
                                                d="M9 15L11 17L15 13"
                                                stroke="currentColor"
                                                strokeWidth="1.7"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>

                                    <h3>
                                        {t("NoOrdersTitle")}
                                    </h3>

                                    <p>
                                        {t("NoOrdersText")}{" "}
                                        {formatFullDate(selectedDate)}
                                        .
                                    </p>
                                </div>
                            ) : (
                                <div className="agenda-list">
                                    {events.map(
                                        (
                                            event,
                                            index
                                        ) => (
                                            <article
                                                className="agenda-event agenda-event-clickable"
                                                key={
                                                    getEventKey(event) ||
                                                    `${event?.pelatis}-${event?.imerominia}-${index}`
                                                }
                                                onClick={() =>
                                                    openEventModal(event)
                                                }
                                                role="button"
                                                tabIndex={
                                                    0
                                                }
                                                onKeyDown={(
                                                    e
                                                ) => {
                                                    if (
                                                        e.key ===
                                                            "Enter" ||
                                                        e.key ===
                                                            " "
                                                    ) {
                                                        e.preventDefault();

                                                        openEventModal(event);
                                                    }
                                                }}
                                            >
                                                <div className="agenda-card">
                                                    <div className="agenda-card-main">
                                                        <h3>
                                                            {event?.pelatis ||
                                                                t(
                                                                    "UntitledCustomer"
                                                                )}
                                                        </h3>

                                                    </div>

                                                    <div className="agenda-card-side">
                                                        <div className="agenda-date-block">
                                                            <span>
                                                                {t("Imerominia")}
                                                            </span>

                                                            <strong>
                                                                {formatShortDate(event?.imerominia)}
                                                            </strong>
                                                        </div>

                                                        <span
                                                            className={`order-status-badge ${getStatusType(event)}`}
                                                        >
                                                            <span className="order-status-dot" />

                                                            {getStatusText(event)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </article>
                                        )
                                    )}
                                </div>
                            )}
                        </section>

                        {selectedEvent && (
                            <div
                                className="webcrm-event-modal-overlay"
                                onMouseDown={(
                                    e
                                ) => {
                                    if (
                                        e.target ===
                                        e.currentTarget
                                    ) {
                                        closeEventModal();
                                    }
                                }}
                            >
                                <div
                                    className="webcrm-event-modal"
                                    role="dialog"
                                    aria-modal="true"
                                >
                                    <div className="webcrm-event-modal-header">
                                        <div className="webcrm-modal-title-area">
                                            <div className="webcrm-modal-title-topline">
                                                <span className="webcrm-modal-eyebrow">
                                                    {t("Pelatis")}
                                                </span>

                                                <span
                                                    className={`order-status-badge ${getStatusType(selectedEvent)}`}
                                                >
                                                    <span className="order-status-dot" />

                                                    {getStatusText(selectedEvent)}
                                                </span>
                                            </div>

                                            <h2>
                                                {selectedEvent?.pelatis ||
                                                    t(
                                                        "UntitledCustomer"
                                                    )}
                                            </h2>
                                        </div>

                                        <button
                                            type="button"
                                            className="webcrm-modal-close"
                                            onClick={closeEventModal}
                                            disabled={modalBusy}
                                            aria-label={t("Close")}
                                        >
                                            ×
                                        </button>
                                    </div>

                                    <div className="webcrm-event-modal-body">
                                        <div className="webcrm-modal-info-grid">

                                            <div className="webcrm-info-card date-card">
                                                <div className="webcrm-info-icon">
                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        width="18"
                                                        height="18"
                                                        fill="none"
                                                    >
                                                        <rect
                                                            x="3"
                                                            y="5"
                                                            width="18"
                                                            height="16"
                                                            rx="3"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                        />

                                                        <path
                                                            d="M7 3V7M17 3V7M3 10H21"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                        />
                                                    </svg>
                                                </div>

                                                <div>
                                                    <span>
                                                        {t("Imerominia")}
                                                    </span>

                                                    <strong className="webcrm-info-date">
                                                        {formatShortDate(selectedEvent?.imerominia)}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="webcrm-info-card">
                                                <div className="webcrm-info-icon">
                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        width="18"
                                                        height="18"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M4 21V8L12 3L20 8V21"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinejoin="round"
                                                        />

                                                        <path
                                                            d="M8 21V14H16V21M8 10H8.01M12 10H12.01M16 10H16.01"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                        />
                                                    </svg>
                                                </div>

                                                <div>
                                                    <span>
                                                        {t("Eteria")}
                                                    </span>

                                                    <strong
                                                        title={
                                                            selectedEvent?.eteria ||
                                                            ""
                                                        }
                                                    >
                                                        {selectedEvent?.eteria ||
                                                            t(
                                                                "NoData"
                                                            )}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="webcrm-info-card">
                                                <div className="webcrm-info-icon status-icon">
                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        width="18"
                                                        height="18"
                                                        fill="none"
                                                    >
                                                        <circle
                                                            cx="12"
                                                            cy="12"
                                                            r="9"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                        />

                                                        <path
                                                            d="M8 12L11 15L16 9"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>

                                                <div>
                                                    <span>
                                                        {t("Katastasi")}
                                                    </span>

                                                    <strong
                                                        title={
                                                            selectedEvent?.katastasi ||
                                                            ""
                                                        }
                                                    >
                                                        {getStatusText(selectedEvent)}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="webcrm-info-card">
                                                <div className="webcrm-info-icon">
                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        width="18"
                                                        height="18"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M3 15V10L6 6H16L20 10V15"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinejoin="round"
                                                        />

                                                        <path
                                                            d="M5 15H19V18H5V15Z"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                        />

                                                        <circle
                                                            cx="7"
                                                            cy="18"
                                                            r="1.5"
                                                            fill="currentColor"
                                                        />

                                                        <circle
                                                            cx="17"
                                                            cy="18"
                                                            r="1.5"
                                                            fill="currentColor"
                                                        />
                                                    </svg>
                                                </div>

                                                <div>
                                                    <span>
                                                        {t("Oxima")}
                                                    </span>

                                                    <strong
                                                        title={
                                                            selectedEvent?.oxima ||
                                                            ""
                                                        }
                                                    >
                                                        {selectedEvent?.oxima ||
                                                            t(
                                                                "NoData"
                                                            )}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div className="webcrm-info-card">
                                                <div className="webcrm-info-icon">
                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        width="18"
                                                        height="18"
                                                        fill="none"
                                                    >
                                                        <circle
                                                            cx="12"
                                                            cy="8"
                                                            r="4"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                        />

                                                        <path
                                                            d="M5 21C5.8 16.8 8.1 15 12 15C15.9 15 18.2 16.8 19 21"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                        />
                                                    </svg>
                                                </div>

                                                <div>
                                                    <span>
                                                        {t("Odigos")}
                                                    </span>

                                                    <strong
                                                        title={
                                                            selectedEvent?.odigos ||
                                                            ""
                                                        }
                                                    >
                                                        {selectedEvent?.odigos ||
                                                            t(
                                                                "NoData"
                                                            )}
                                                    </strong>
                                                </div>
                                            </div>

                                        </div>

                                        <section className="webcrm-sxolia-panel">
                                            <div className="webcrm-sxolia-heading">
                                                <div>
                                                    <span className="webcrm-panel-label">
                                                        {t("Sxolia")}
                                                    </span>

                                                    <small>
                                                        {t("EditableField")}
                                                    </small>
                                                </div>

                                                {hasSxoliaChanged && (
                                                    <span className="webcrm-unsaved-badge">
                                                        {t("UnsavedChanges")}
                                                    </span>
                                                )}
                                            </div>

                                            <textarea
                                                value={editedSxolia}
                                                onChange={(
                                                    e
                                                ) =>
                                                    setEditedSxolia(
                                                        e
                                                            .target
                                                            .value
                                                    )
                                                }
                                                className="webcrm-sxolia-textarea"
                                                disabled={modalBusy}
                                                placeholder={t("SxoliaPlaceholder")}
                                            />
                                        </section>

                                        {saveEventError && (
                                            <div className="webcrm-modal-error">
                                                <div className="error-icon">
                                                    !
                                                </div>

                                                <span>
                                                    {saveEventError}
                                                </span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="webcrm-event-modal-footer">
                                        <div className="webcrm-modal-footer-left">

                                            <button
                                                type="button"
                                                className="webcrm-modal-complete-btn"
                                                onClick={completeEvent}
                                                disabled={
                                                    modalBusy ||
                                                    isEventDone(selectedEvent)
                                                }
                                            >
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    width="17"
                                                    height="17"
                                                    fill="none"
                                                >
                                                    <circle
                                                        cx="12"
                                                        cy="12"
                                                        r="9"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                    />

                                                    <path
                                                        d="M8 12L11 15L16 9"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>

                                                {isCompletingEvent
                                                    ? t(
                                                          "Completing"
                                                      )
                                                    : isEventDone(selectedEvent)
                                                    ? t(
                                                          "Completed"
                                                      )
                                                    : t(
                                                          "MarkCompleted"
                                                      )}
                                            </button>

                                            <button
                                                type="button"
                                                className="webcrm-modal-cancel-status-btn"
                                                onClick={cancelEvent}
                                                disabled={
                                                    modalBusy ||
                                                    isEventCanceled(selectedEvent)
                                                }
                                            >
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    width="17"
                                                    height="17"
                                                    fill="none"
                                                >
                                                    <circle
                                                        cx="12"
                                                        cy="12"
                                                        r="9"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                    />

                                                    <path
                                                        d="M9 9L15 15M15 9L9 15"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>

                                                {isCancelingEvent
                                                    ? t(
                                                          "Canceling"
                                                      )
                                                    : isEventCanceled(selectedEvent)
                                                    ? t(
                                                          "Canceled"
                                                      )
                                                    : t(
                                                          "MarkCanceled"
                                                      )}
                                            </button>

                                            <button
                                                type="button"
                                                className="webcrm-modal-read-status-btn"
                                                onClick={readEvent}
                                                disabled={
                                                    modalBusy ||
                                                    isEventRead(selectedEvent)
                                                }
                                            >
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    width="17"
                                                    height="17"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M3 12C5.5 7.5 8.5 6 12 6C15.5 6 18.5 7.5 21 12C18.5 16.5 15.5 18 12 18C8.5 18 5.5 16.5 3 12Z"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinejoin="round"
                                                    />

                                                    <circle
                                                        cx="12"
                                                        cy="12"
                                                        r="2.5"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                    />
                                                </svg>

                                                {t("Read")}
                                            </button>

                                        </div>

                                        <div className="webcrm-modal-footer-actions">
                                            <button
                                                type="button"
                                                className="webcrm-modal-save-btn"
                                                onClick={saveEventSxolia}
                                                disabled={
                                                    !hasSxoliaChanged ||
                                                    modalBusy
                                                }
                                            >
                                                {isSavingEvent
                                                    ? t(
                                                          "Saving"
                                                      )
                                                    : t(
                                                          "Save"
                                                      )}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )}

                    </main>
                </div>
            </div>
        </div>
    );
};

export default WebCRM;